import { render, staticRenderFns } from "./EditInstanceForm.vue?vue&type=template&id=37b60214&"
import script from "./EditInstanceForm.vue?vue&type=script&lang=js&"
export * from "./EditInstanceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports